import { setSession, getSession, removeSession } from './index'

import { ACCEPT_TERMS_POLICE } from '@Constants/SessionStorage'

export const setAcceptTermsPoliceData = (data) =>
  setSession(ACCEPT_TERMS_POLICE, data)

export const getAcceptTermsPoliceData = () => {
  try {
    const data = getSession(ACCEPT_TERMS_POLICE)
    if (typeof data === 'boolean') return data
    throw new Error('Invalid Data')
  } catch (err) {
    console.warn(err.message)
    removeSession(ACCEPT_TERMS_POLICE)
    return false
  }
}
